import React, { useState, useEffect } from "react";
import "./PaymentModal.css";
import { useNavigate } from "react-router-dom";

export default function PaymentModal({
  onClose,
  user_id,
}) {
  

  const [email, setEmail] = useState("");

  const handleSelectPlan = async (plan) => {
    if (email.trim() !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      alert("Введите корректный email");
      return;
    }

    const finalEmail = email.trim() === "" ? "nobigmotion@gmail.com" : email;

    const API_ENDPOINT = `/api/subscription/link?user_id=${user_id}&email=${finalEmail}`;
    const response = await fetch(API_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error("Failed to select plan");
    }
    const data = await response.json();
    window.open(data, "_blank");
  };

  return (
    <div className="payment-modal-backdrop">
      <div className="send-modal-content">
        <button className="payment-modal-close" onClick={onClose}>
          &times;
        </button>
        <h2>Введите свой email для получения чека</h2>
        <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="send-input"
          />
          <button className="send-to-payment-btn" onClick={() => handleSelectPlan("Premium")}>
          Оплатить
        </button>
      </div>
    </div>
  );
}
